import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ILesson } from '../../../core/models/disciplines';

interface LessonState {
  lessons: ILesson[];
  setLessons: (lessons: ILesson[]) => void;
  markLessonAsDone: (slug: string) => void;
  resetLesson: () => void;
}

export const useLessonStore = create<LessonState>()(
  persist(
    (set) => ({
      lessons: [],
      setLessons: (lessons: ILesson[]) => set({ lessons: lessons }),
      markLessonAsDone: (slug: string) => set((state) => ({
        lessons: state.lessons.map((lesson) =>
          lesson.slug === slug ? { ...lesson, done: true } : lesson
        )
      })),
      resetLesson: () => set({
        lessons: [],
      })
    }),
    {
      name: 'discipline-lesson',
      version: 1,
      partialize: (state) => ({ lessons: state.lessons }),
      migrate: (persistedState, version) => {
        if (version === 0) {
          return { lessons: [] } as unknown as LessonState;
        }
        return persistedState as LessonState;
      }
    }
  )
);
